import { staticText } from "../../../statics/static-text";

// TEXT
export const text = staticText.tableColumns;

// STYLES

// DATA

// TYPES
export type Props = {
  date: Date;
  defaultText?: string;
  className?: string;
};

// CONSTANTS

// FUNCTIONS
